import script from "./HomeChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeChoice.vue?vue&type=script&setup=true&lang=js"

import "./HomeChoice.vue?vue&type=style&index=0&id=1b18f1ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b18f1ae"]])

export default __exports__